import { Routes, Route } from "react-router-dom";
import NewsAuswahl from './NewsAuswahl';
import NewsEintrag from "./NewsEintrag";

function NewsTicker(props) {
    const { client, accessToken, updateTitle } = props;

    return (
        <Routes>
            <Route path="/NEWSID/*" element={<NewsEintrag updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} />} />
            <Route path="/" element={<NewsAuswahl updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} />} />
        </Routes>
    );
}

export default NewsTicker;
